import {StyleSheet} from 'react-native';

import {darkRed} from '/theme/color/secondary.color';

export const styles = StyleSheet.create({
  bonusIndicatorText: {
    color: darkRed,
    fontSize: 12,
    fontWeight: '600',
  },
});
